<!-- =========================================================================================
    File Name: AgGridTable.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="billing-view-container">
    <!-- Filters Section -->
    <div class="filters-section">
      <div class="filters-header">
        <h3 class="filters-title">
          <feather-icon icon="SlidersIcon" svgClasses="w-4 h-4" />
          Filtros
        </h3>
      </div>
      <div class="filters-inline-row">
        <div class="filter-item">
          <label class="filter-label">Holding <span class="required">*</span></label>
          <holding-select ref="holdingSelect" @value="filters.holdings = $event" @companies="companies = $event" @clearCompanies="clearCompanies"/>
        </div>

        <div class="filter-item">
          <label class="filter-label">Cliente <span class="required">*</span></label>
          <companies-select
            @value="filters.companies = $event"
            :companies="companies"
            ref="companiesSelect"
          />
        </div>

        <div class="filter-item filter-item--xs">
          <label class="filter-label">ID Campaña</label>
          <input type="text" v-model="filters.campaignId" placeholder="ID" class="filter-input" />
        </div>

        <div class="filter-item filter-item--sm">
          <label class="filter-label">Estado</label>
          <select v-model="filters.status" class="filter-native-select">
            <option value="unbilled">No facturado</option>
            <option value="billed">Facturado</option>
          </select>
        </div>

        <div class="filter-item">
          <label class="filter-label">Fecha de vencimiento</label>
          <flat-pickr
            width="100%"
            class="date-picker"
            :config="configDateRangeCampaignsTimePicker"
            v-model="dateRange"
            placeholder="Desde - Hasta"
            @on-close="onDateRangeCampaignsChange"
          />
        </div>

        <div class="filter-actions">
          <div class="filter-label-spacer"></div>
          <div class="filter-buttons">
            <vs-button @click="searchData" color="primary" class="search-btn">Buscar</vs-button>
            <vs-button @click="clearFilters" type="border" class="clear-btn">Limpiar</vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <billing-table
      :filters="filters"
      ref="campaignsBilling"
    ></billing-table>
  </div>
</template>

<style lang="scss">
@import './css/billing-charges-filters.scss';
</style>

<style scoped>
.billing-view-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
}

/* campaings.scss sets .flatpickr-input + input { width: 90% } — override it */
::v-deep .flatpickr-input.form-control {
  width: 100% !important;
  height: 40px !important;
  padding: 0 12px !important;
  font-size: 13px !important;
  border: 1px solid #dde1e7 !important;
  border-radius: 8px !important;
  background: #fafbfc !important;
  line-height: 40px !important;
  box-sizing: border-box !important;
}

::v-deep .flatpickr-input.form-control:focus {
  border-color: #2196F3 !important;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.12) !important;
  background: #fff !important;
}
</style>

<script>
import { LicenseManager } from 'ag-grid-enterprise'
LicenseManager.setLicenseKey(
    'CompanyName=Servoy B.V.,LicensedApplication=Servoy,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=7,LicensedProductionInstancesCount=200,AssetReference=AG-010463,ExpiryDate=11_October_2021_[v2]_MTYzMzkwNjgwMDAwMA==4c6752fe4cb2066ab1f0e9c572bc7491'
)
import BillingTable from './BillingTable.vue'
import flatPickr from 'vue-flatpickr-component'
import HoldingSelect from '../components/holding-select/HoldingSelect.vue'
import CompaniesSelect from '../components/companies-select/CompaniesSelect.vue'

import './css/campaings.scss'
import 'flatpickr/dist/flatpickr.css'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import moment from 'moment'

export default {
  components: {
    flatPickr,
    BillingTable,
    HoldingSelect,
    CompaniesSelect,
  },
  data() {
    const today = moment().format('YYYY-MM-DD')
    const in15Days = moment().add(15, 'days').format('YYYY-MM-DD')
    return {
      companies: [],
      dateRange: [today, in15Days],
      filters: {
        holdings: [],
        companies: [],
        dateRange: [today, in15Days],
        status: 'unbilled',
        campaignId: ''
      },
      configDateRangeCampaignsTimePicker: {
        locale: SpanishLocale,
        minDate: null,
        mode: 'range',
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        defaultDate: [today, in15Days],
        inline: false
      },
    }
  },
  mounted() {
    // Auto-load data on component mount
    this.searchData()
  },
  methods: {
    searchData() {
      this.$refs.campaignsBilling.forceSearch({ page: 1 })
    },
    clearFilters() {
      const today = moment().format('YYYY-MM-DD')
      const in15Days = moment().add(15, 'days').format('YYYY-MM-DD')
      this.filters = {
        holdings: [],
        companies: [],
        dateRange: [today, in15Days],
        status: 'unbilled',
        campaignId: ''
      }
      this.dateRange = [today, in15Days]
      this.$refs.holdingSelect.clearHoldings()
      this.$refs.companiesSelect.clearCompanies()
      this.$nextTick(() => {
        this.$refs.campaignsBilling.forceSearch()
      })
    },
    clearCompanies() {
      this.$refs.companiesSelect.clearCompanies()
    },
    onDateRangeCampaignsChange(dateRange) {
      let dateFrom = null
      let dateTo = null

      if (dateRange.length === 2) {
        dateFrom = moment(dateRange[0]).format('YYYY-MM-DD')
        dateTo = moment(dateRange[1]).format('YYYY-MM-DD')
      }

      this.filters.dateRange = [dateFrom, dateTo]
    }
  },
}
</script>
